import { render, staticRenderFns } from "./FarmForm.vue?vue&type=template&id=2b22d166&scoped=true&"
import script from "./FarmForm.vue?vue&type=script&lang=js&"
export * from "./FarmForm.vue?vue&type=script&lang=js&"
import style0 from "./FarmForm.vue?vue&type=style&index=0&id=2b22d166&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b22d166",
  null
  
)

export default component.exports